/**
 * @prop --height: Height of item
 * @prop --icon-size: Size of icon next to item
 * @prop --color: Color of item
 * @prop --background-color: Background color of item
 * @prop --hover-color: Hover color of item
 * @prop --hover-background-color: Hover background color of item
 *
 * @prop --stzh-menu-item-height: **Global**: Height of items
 */

:host {
  --height: var(--stzh-menu-item-height);
  --color: #{$colorBlack};
  --background-color: transparent;
  --icon-size: #{iconSize("small")};
  --padding-top: #{space("xsmall")};
  --padding-bottom: #{space("xsmall")};
  --padding-left: #{space("large")};
  --padding-right: #{space("large")};

  --hover-color: var(--stzh-popover-item-hover-color, #{$colorBlack});
  --hover-background-color: var(--stzh-popover-item-hover-bg, #{$colorGrey20});

  &[size="large"] {
    --icon-size: #{iconSize()};
    --height: var(--stzh-menu-large-item-height);
    --padding-left: #{space("xlarge")};
    --padding-right: #{space("xlarge")};
  }

  &[variant="secondary"] {
    --color: #{$colorPrimary70};

    --hover-color: #{$colorPrimary70};
    --hover-background-color: #{$colorSecondary30};
  }

  &[active]:not([active="false"]) {
    --color: #{$colorPrimary70};
    --hover-color: #{$colorPrimary70};
    --hover-background-color: #{$colorGrey20};
  }

  &[disabled]:not([disabled="false"]) {
    --color: #{$colorGrey70};
    --background-color: #{$colorGrey10};

    --hover-color: #{$colorGrey70};
    --hover-background-color: #{$colorGrey10};
  }
}

.stzh-menu-item {
  @include fontSize("micro");
  font-family: inherit;
  display: flex;
  gap: space("small");
  align-items: center;
  justify-content: stretch;
  appearance: none;
  text-decoration-line: none;
  border: none;
  padding-top: var(--padding-top);
  padding-bottom: var(--padding-bottom);
  padding-left: var(--padding-left);
  padding-right: var(--padding-right);
  color: var(--color);
  background-color: var(--background-color);
  width: 100%;
  height: var(--height);
  line-height: var(--height);
  transition-duration: $baseTransitionAnimationSpeed;
  transition-property: color, background-color, border-color;
  cursor: pointer;

  &:hover {
    color: var(--hover-color);
    background-color: var(--hover-background-color);
  }

  &__icon-wrapper {
    --stzh-icon-size: var(--icon-size);

    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: auto;
    height: 1em;
  }

  &__badge {
    position: absolute;
    z-index: 1;
    top: calc(#{space("xsmall")} * -1);
    right: calc(#{space("xsmall")} * -1);
  }

  &__text-wrapper {
    display: flex;
    gap: space("xsmall");
  }

  &__counter {
    @include font;
  }

  &__text {
    @include truncate;
  }

  /* Large variant */

  &--size-large {
    @include fontSize("milli");
    gap: space("medium");
  }

  /* Disabled variant */

  &--is-disabled {
    cursor: not-allowed;
  }
}
